<div class="modal-header border-0">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-4 mt-3"
		>Détail de l'activité</span
	>
	<button
		type="button"
		class="btn-close custom-button-close border border-white rounded-circle bg-white fs-4"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
	<div class="">
		<button
			class="btn theme-main-color-button mx-3 px-3"
			(click)="editForm()"
		>
		<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier
		</button>
	</div>
	<div class="">
		<a
			(click)="openModal(deleteActivity)"
			class="btn theme-red-button px-4"
		>
			Supprimer
		</a>
	</div>
</div>
<div class="modal-body">
	<div *ngIf="isFormReadOnly" class="row">
		<div class="">
			<div class="row">
				<div class="row mt-4 px-lg-5 px-2">
					<span class="theme-main-color fs-4 col">Informations</span>
					<!-- <a
						[routerLink]="['/gestion/formations', missionRequest?.id]"
						[queryParams]="{ redirected: true }"
						class="btn col-4 theme-main-color-button"
						(click)="bsModalRef.hide()"
						><i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier le suivi</a
					> -->
				</div>
			</div>
			<div class="row my-5 px-lg-5 px-2">
				<div class="col-8">
					<div *ngIf="this.activitePrestation?.cotraitant" class="row my-4">
						<div class="col">
							<span
								for="cotraitant"
								class="theme-main-color fw-bold form-label row my-2"
								>Soutien pour le compte du cotraitant
							</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="intervenant"
								class="theme-main-color fw-bold form-label row my-2"
								>Intervenant
							</span>
							<span class="row my-2" id="intervenant">{{
								activitePrestation?.intervenant?.firstName + ' ' + activitePrestation?.intervenant?.lastName
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="dateEntretien"
								class="theme-main-color fw-bold form-label row my-2"
								>Date d'entretien</span
							>
							<span class="row my-2" id="dateEntretien">{{
								activitePrestation?.dateEntretien | date : 'dd/MM/yyyy HH:mm'
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="modaliteReunion"
								class="theme-main-color fw-bold form-label row my-2"
								>Modalité réunion
							</span>
							<span class="row my-2" id="modaliteReunion">{{
								activitePrestation?.modaliteReunion?.name
							}}</span>
						</div>
						<!-- <div class="col-6">
							<span
								for="typeEntretien"
								class="theme-main-color fw-bold form-label row my-2"
								>Type entretien
							</span>
							<span class="row my-2" id="typeEntretien">{{
								activitePrestation?.typeEntretien?.name
							}}</span>
						</div> -->
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="chargeTravail"
								class="theme-main-color fw-bold form-label row my-2"
								>Charge de travail
							</span>
							<span class="row my-2" id="chargeTravail">{{
								activitePrestation?.chargeTravail
							}} heure(s)</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="tache"
								class="theme-main-color fw-bold form-label row my-2"
								>Type entretien
							</span>
							<span class="row my-2" id="tache">{{
								activitePrestation?.tache?.name
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="dateProchainEntretien"
								class="theme-main-color fw-bold form-label row my-2"
								>Date du prochain entretien</span
							>
							<span class="row my-2" id="dateProchainEntretien">{{
								activitePrestation?.dateProchainEntretien | date : 'dd/MM/YYYY HH:mm'
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="description"
								class="theme-main-color fw-bold form-label row my-2"
								>Description</span
							>
							<span class="row my-2" id="description">{{
								activitePrestation?.description 
							}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<app-activitePrestation-form
				*ngIf="!isFormReadOnly"
				[activitePrestation]="activitePrestation"
				[isAddForm]="false"
				[form]="form"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
	>
	</app-activitePrestation-form>
	<div class="row my-4">
		<div class="d-flex justify-content-end">
			<button
				*ngIf="!isFormReadOnly"
				class="btn theme-main-color-button mx-3 px-3"
				(click)="stopEditForm()"
			>
				Annuler
			</button>
			<button
				*ngIf="!isFormReadOnly"
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</div>
<ng-template #deleteActivity>
	<div class="modal-header text-center">
		<h4>Suppression</h4>
		<button
			type="button"
			class="btn-close pull-right"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		></button>
	</div>
	<div class="modal-body">
		Êtes-vous sûr de vouloir effectuer la suppression ?
	</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="delete(activitePrestation)"
			>Supprimer</a
		>
	</div>
</ng-template>